import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';

class SimpleMenu extends React.Component {

    render() {        

        return (
            <div>
                <IconButton
                    aria-owns={this.props.propMenuHandlers.propMenuState ? 'simple-menu' : null}
                    aria-haspopup="true"
                    onClick={this.props.propMenuHandlers.propHandleMenu}
                    color="inherit"
                    aria-label="menu"
                >
                    <MoreVertIcon/>
                </IconButton>
                <Menu
                    id="simple-menu"
                    anchorEl={this.props.propMenuHandlers.propMenuState}
                    open={Boolean(this.props.propMenuHandlers.propMenuState)}
                    onClose={this.props.propMenuHandlers.propHandleMenu}
                >
                    {this.props.propMenuHandlers.propMenuItems.map(item => ( 
                        <MenuItem key={item[0]} onClick={item[1]}>{item[0]}</MenuItem>
                    ))}
                </Menu>
            </div>
        );
    }
}

export default SimpleMenu;



// WEBPACK FOOTER //
// ./src/components/material-ui/SimpleMenu.js